/**
 * `security/policies.ts`'nin web karşılığı. Masaüstündeki pencere/oturum
 * sertleştirmesinin karşılığı web'de içerik güvenliği politikası (CSP,
 * webapp/public/_headers). Buradan yalnızca harici bağlantı açma kalıyor.
 */

const SAFE_EXTERNAL_PROTOCOLS = new Set(['https:', 'http:', 'mailto:']);

/** Bağlantıyı yeni sekmede açar — yalnızca güvenli protokollerde. */
export function openExternalSafely(rawUrl: string): boolean {
  let parsed: URL;
  try {
    parsed = new URL(rawUrl);
  } catch {
    return false;
  }
  if (!SAFE_EXTERNAL_PROTOCOLS.has(parsed.protocol)) return false;
  if (parsed.protocol === 'mailto:') {
    window.location.href = parsed.toString();
    return true;
  }
  // Her zaman yeni sekme: aynı sekmede açılırsa süren kayıt kaybolurdu.
  // (`noopener` ile window.open hep null döndürdüğü için engellenme ayırt edilemiyor.)
  window.open(parsed.toString(), '_blank', 'noopener,noreferrer');
  return true;
}

export function isTrustedUrl(url: string): boolean {
  try {
    return new URL(url).origin === window.location.origin;
  } catch {
    return false;
  }
}
